import { Tag } from "antd"
import { formatPrice } from "../../utils/formatPrice";

export const PriceTag = ({ price, size }) => {
   
    const formatedPrice = formatPrice(Number(price))
  

    return (
      <Tag
        color="white"
        style={{
          color: "var(--dark-accent)",
          borderColor: "var(--dark-accent)",
          borderRadius: "10px",
          borderWidth: ".5px",
          fontWeight: "bold",
          fontSize: size
        }}
      >
      {formatedPrice + "€"}
      </Tag>
    );
}